import { render, staticRenderFns } from "./Powerlink.vue?vue&type=template&id=127076c0"
import script from "./Powerlink.vue?vue&type=script&lang=ts"
export * from "./Powerlink.vue?vue&type=script&lang=ts"
import style0 from "./Powerlink.vue?vue&type=style&index=0&id=127076c0&prod&module=true&lang=css"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports